export default __webpack_public_path__ + "514a5e98eca7ef410862953d7255c9fc.svg";